import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UseAuth } from "../hooks/auth";

const ProtectedRoute = ({ redirectPath = "/", children }) => {
  const auth = UseAuth();

  if (!auth) {
    return <Navigate to={redirectPath} replace />;
  }
  return children || <Outlet />;
};

export default ProtectedRoute;
